import type { Root, Element } from "hast";

function extractText(node: Element): string {
  return node.children
    .reduce((acc, child) => {
      if (child.type === "text") return acc + child.value;

      if (child.type === "element") return acc + extractText(child);

      return acc;
    }, "")
    .trim();
}

function getChildElements(node: Element, tag: string): Element[] {
  return node.children.filter((c): c is Element => c.type === "element" && c.tagName === tag);
}

function processTable(table: Element): void {
  const thead = getChildElements(table, "thead")[0];
  const tbody = getChildElements(table, "tbody")[0];

  if (!thead || !tbody) return;

  const headerRow = getChildElements(thead, "tr")[0];

  if (!headerRow) return;

  const headers = getChildElements(headerRow, "th").map(extractText);

  if (headers.length === 0) return;

  for (const row of getChildElements(tbody, "tr")) {
    const cells = getChildElements(row, "td");

    cells.forEach((td, i) => {
      const label = headers[i];
      if (label && !td.properties["data-label"]) {
        td.properties["data-label"] = label;
      }
    });
  }
}

export function rehypeTableDataLabels() {
  return (tree: Root) => {
    const visit = (node: Element | Root) => {
      const children = node.children as Element[];

      children.forEach((child) => {
        if (child.type !== "element") return;

        if (child.tagName === "table") processTable(child);
        else visit(child);
      });
    };

    visit(tree);
  };
}
